export default "__VITE_ASSET__0$5w4vF2CxwJn5AYBhKPyw__"